import { NewDriveItemAction, NewDriveItemActionKeys } from './actions';

export interface NewDriveItemState {
	isLoaded: boolean;
	isFetching: boolean;
	lastVisitDate?: Date;
	lastCheckDate?: Date;
	driveItemIds: number[];
}

const initialState: NewDriveItemState = {
	isLoaded: false,
	isFetching: false,
	driveItemIds: [],
	lastVisitDate: undefined,
	lastCheckDate: undefined
};

export function newDriveItems(state: NewDriveItemState = initialState, action: NewDriveItemAction): NewDriveItemState {
	switch (action.type) {
		case NewDriveItemActionKeys.INIT_LAST_VISIT_DATE:
			return {
				...state,
				lastVisitDate: action.lastVisitDate
			};
		case NewDriveItemActionKeys.REQUEST_NEW_DRIVE_ITEMS:
			return {
				...state,
				isFetching: true
			};
		case NewDriveItemActionKeys.RECEIVE_NEW_DRIVE_ITEMS:
			return {
				...state,
				isLoaded: true,
				isFetching: false,
				driveItemIds: action.driveItemIds,
				lastCheckDate: action.lastCheckDate
			};
		default:
			return state;
	}
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/DriveItemList/New/reducer.ts